<template>
  <div class="vnft">
    <div v-if="isConnected && isLoaded">
      <div class="container m-auto text-gray-900">
        <div
          class="flex flex-col justify-start items-center mt-8 mb-10 bg-blue-700 bg-opacity-25 border-0 border-black rounded-xl p-8 md:p-8 mx-4"
        >
          <div
            class="flex flex-col md:flex-row w-full justify-between items-start md:items-center mb-8 md:mb-0 border-b border-gray-700 border-opacity-60 pb-8"
          >
            <div
              class="flex flex-col w-full md:w-6/12 justify-start items-start mb-4 md:mb-0"
            >
              <div class="flex items-center w-2/3 md:w-2/3 ml-0 mt-0">
                <div class="">SCORE</div>
                <div class="px-2 text-2xl leading-normal">{{ score }}</div>
                <div class="w-full">
                  <div
                    class="meter h-8 relative overflow-hidden rounded min-width-full"
                  >
                    <span
                      style="width: 100%"
                      class="block border rounded border-dark"
                      ><span
                        class="progress block w-full bg-blue-500 rounded"
                      ></span
                    ></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex space-x-4 justify-between w-full md:justify-end">
              <div class="flex items-center mt-0 w-auto">
                <a
                  @click="claimTokens"
                  v-if="isOwner"
                  class="cursor-pointer block text-center w-auto mx-auto border-2 border-gray-900 bg-gray-900 bg-opacity-100 hover:text-gray-900 hover:bg-white text-white font-light py-1 px-6 text-md rounded-lg"
                >
                  Claim
                  <span class="font-normal text-md"
                    ><Number decimals="18" :number="expectedReward"
                  /></span>
                  $ROYAL
                </a>
              </div>
              <div
                class="flex flex-rol justify-center items-center w-auto rounded-lg bg-white bg-opacity-25 px-4 shadow-md"
              >
                <img class="h-8 mr-2" src="../assets/img/skull.svg" /><span
                  class="text-lg mr-1"
                  >TOD:</span
                >
                <span v-if="isNftAlive" class="text-red-600">
                  <countdown :end-time="timeUntilStarving">
                    <template v-slot:process="time">
                      <div class="">
                        {{ `${time.timeObj.d}d` }}

                        {{
                          ` ${time.timeObj.h}hrs ${time.timeObj.m}m ${time.timeObj.s}s`
                        }}
                      </div>
                    </template>
                    <template v-slot:finish>
                      <span>Dead!</span>
                    </template>
                  </countdown>
                </span>
                <span v-else class="text-red-600">Dead</span>
              </div>
            </div>
          </div>
          <div class="relative w-full md:w-2/3 px-3">
            <div class="w-full text-center text-2xl text-red-500">
              <div
                v-if="!isOwner"
                class="flex flex-col items-center justify-center"
              >
                <div class="flex flex-col items-center mt-2 md:mt-8">
                  <span class="text-xl leading-normal text-black"
                    >Player ID #{{ id }}</span
                  >
                  <span class="text-lg text-black font-light mb-4">
                    Owned by
                    <Address :address="owner" />
                  </span>
                </div>
              </div>
              <div v-if="isOwner" class></div>
            </div>
            <div
              class="nftCard2 rounded flex justify-start items-center border-0 p-0 border-gray-900 flex-col bg-white bg-opacity-50 mt-8"
            >
              <div class="flex w-full justify-center items-center mx-auto mt-2">
                <div
                  v-if="!isNftAlive"
                  class="text-3xl cursor-pointer"
                  @click.stop="fatality"
                >
                  <img
                    class="w-12"
                    src="../assets/img/skull.svg"
                    alt="Attack MENU"
                  />
                </div>
                <div
                  v-if="isNftAlive"
                  class="text-3xl cursor-pointer"
                  @click.stop="fatality"
                >
                  <img
                    class="w-12 invisible"
                    src="../assets/img/skull.svg"
                    alt="Attack MENU"
                  />
                </div>
              </div>
              <div class="flip-box">
                <div class="flip-box-inner">
                  <div class="flip-box-front relative -mt-2">
                    <img
                      :src="image"
                      alt="Person"
                      class="mt-6 m-auto object-contain h-40 w-8/12 px-2"
                      style=""
                    />
                  </div>
                </div>
              </div>

              <div
                class="my-0 text-2xl text-white leading-tight text-center flex flex-col mt-10"
              >
                <span class="text-sm text-white font-light mb-2"
                  >ID #{{ id }}</span
                >
                <span v-if="!isOwner" class="hidden">
                  <span
                    class="field-value block"
                    v-show="!showField('name')"
                    @click="focusField('name')"
                    >{{ name }}</span
                  >
                  <input
                    v-model="name"
                    v-show="showField('name')"
                    id="name"
                    type="text"
                    class="field-value form-control text-gray-900"
                    @focus="focusField('name')"
                    @blur="blurField('name')"
                  />
                </span>
                <span class="" v-if="true">{{ name }}</span>
              </div>
              <div class="flex text-lg text-white font-light mb-4">
                <div class="px-3 text-center">
                  Level:
                  <span>{{ level }}</span>
                </div>
                <!-- <div class="px-3 text-center">
                  Score
                  <span>{{ score }}</span>
                </div>-->
              </div>
              <div class="w-2/3 m-0"></div>
            </div>
          </div>
          <div class="flex w-full md:w-1/3 px-3 mt-8">
            <div
              v-if="isOwner"
              id="items"
              class="w-full market flex flex-col justify-between md:justify-start flex-wrap leading-tight"
            >
              <div class="text-center font-light text-lg">
                1 $ROYAL = {{ oneRoyalInTod }} hours of tod
              </div>
              <input
                type="number"
                :min="1"
                v-model="buyTodWithAmount"
                placeholder="ROYAL Amount"
                class="w-full border-2 border-gray-900 bg-white bg-opacity-100 font-light text-gray-900 py-2 px-3 mt-2 text-md rounded-md"
              />

              <button
                @click="buyPowerUp"
                type="button"
                class="hover:bg-white hover:text-gray-900 focus:outline-none w-full border-2 border-gray-900 bg-gray-900 bg-opacity-100 text-white py-4 px-3 mt-4 text-md rounded-lg mb-8"
              >
                Buy {{ calculatedTod }} hours TOD
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ConnectWallet />
  </div>
</template>

<script>
import moment from "moment";
import BigNumber from "bignumber.js";

// @ is an alias to /src
import NFT from "@/components/NFT.vue";
import ConnectWallet from "@/components/ConnectWallet.vue";
import Number from "@/components/Number.vue";
import Address from "@/components/Address.vue";
import ColorPicker from "@/components/tools/ColorPicker.vue";

export default {
  name: "vNFT",
  components: {
    NFT,
    ConnectWallet,
    Number,
    Address,
    ColorPicker,
  },
  data: function () {
    return {
      editField: "",
      name: "",
      addressOrigin: "",
      idOrigin: "",
      isNftAlive: true,
      timeUntilStarving: 0,
      timeVnftBorn: 0,
      lastTimeMined: 0,
      expectedReward: 0,
      score: 0,
      level: 0,
      id: 0,
      hasTokenApproval: false,
      isOwner: false,
      owner: "",
      loader: false,
      isLoaded: false,
      image: null,
      buyTodWithAmount: 1.01,
      color: "rgba(71,154,104, 39)",
      challengesUsed: 0,
      oneRoyalInTod: 0,
    };
  },
  mounted: async function () {
    this.id = this.$route.params.id;
    this.fetchPlayerInfo();
    const context = this;

    var score = new Audio(require("../assets/audio/Picked Coin Echo.wav"));
    setInterval(async () => {
      this.score++;
      // score.play();
    }, 3000);
  },
  methods: {
    fetchPlayerInfo: async function () {
      if (this.$store.state.web3 == null) {
        return;
      }

      let infos = await this.$store.state.GameContract.methods
        .getInfo(this.id)
        .call();
      console.log(infos);
      this.expectedReward = parseInt(infos._expectedReward);
      this.timeUntilStarving =
        Date.now() + parseInt(infos._timeUntilDeath) * 1000;
      this.timeBorn = parseInt(infos._timeBorn * 1000);
      this.score = parseInt(infos._score) / 100;
      this.level = parseInt(infos._score / 100);
      this.owner = infos._owner;

      this.isNftAlive = this.timeUntilStarving > 0;
      this.isOwner =
        this.owner.toLowerCase() == this.$store.state.account.toLowerCase();

      let oneRoyalInTod = await this.$store.state.GameContract.methods
        .getAmountOfTOD("1000000000000000000")
        .call();
      this.oneRoyalInTod = oneRoyalInTod / 60 / 60;
      try {
        const { data } = await axios.get(
          `https://api.nft20.io/game/player/${this.id}`
        );
        this.image = data.nft_image;
        this.name = data.nft.nft_title;
      } catch (error) {}

      console.log(infos);
      this.hasTokenApproval =
        (
          await this.$store.state.RoyalTokenContract.methods
            .allowance(
              this.$store.state.account,
              this.$store.state.contracts.Game
            )
            .call()
        ).length >= 18;

      this.isLoaded = true;
      let context = this;

      await this.updateBalance();
    },
    claimTokens: async function () {
      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          canCanel: true,
          // onCancel: this.onCancel,
        });

        let minetx = await this.$store.state.GameContract.methods
          .claimTokens()
          .send({
            from: this.$store.state.account,
          });

        console.log(minetx);
        this.fetchPlayerInfo();
        this.loader.hide();

        this.$notify({
          group: "foo",
          title: "Success",
          text: `TX Hash: ${minetx.blockHash}`,
          type: "success",
        });
      } catch (e) {
        this.loader.hide();
        this.$notify({
          group: "foo",
          title: "Error",
          text: `There was an error with the tx`,
          type: "error",
        });
      }
    },

    approve: async function () {
      let max =
        "115792089237316195423570985008687907853269984665640564039457584007913129639935";
      let remove = "0";
      let minetx = await this.$store.state.RoyalTokenContract.methods
        .approve(this.$store.state.contracts.Game, max)
        .send({
          from: this.$store.state.account,
        });
      this.fetchPlayerInfo();
    },
    buyPowerUp: async function (id) {
      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel,
        });
        if (!this.hasTokenApproval) {
          await this.approve();
        }

        alert(this.buyTodWithAmount);

        let minetx = await this.$store.state.GameContract.methods
          .buyPowerUp(
            this.id,
            (parseInt(this.buyTodWithAmount) * 10 ** 18).toString()
          )
          .send({
            from: this.$store.state.account,
          });

        this.fetchPlayerInfo();

        this.loader.hide();

        this.$notify({
          group: "foo",
          title: "Success",
          text: `TX Hash: ${minetx.blockHash}`,
          type: "success",
        });
      } catch (e) {
        this.loader.hide();
        this.$notify({
          group: "foo",
          title: "Error",
          text: `There was an error with the tx`,
          type: "error",
        });
      }
    },
    updateBalance: async function () {
      let balance = await this.$store.state.RoyalTokenContract.methods
        .balanceOf(this.$store.state.account)
        .call();
      this.balance = new BigNumber(balance).shiftedBy(-18).toNumber();
    },

    focusField: function (field) {
      this.editField = field;
    },
    blurField: function (field) {
      this.editField = "";
      if (field == "description") {
        this.saveDescription();
      } else if (field == "name") {
        this.saveName();
      }
    },
    showField: function (field) {
      if (field == "name") {
        return this.name == "" || this.editField == field;
      } else if (field == "description") {
        return this.description == "" || this.editField == field;
      }
    },
    saveName: async function () {
      // const web3 = this.$store.state.web3;
      const sign = await web3.personal.sign(
        web3.fromUtf8(this.name),
        web3.eth.coinbase,
        async (obj, signature) => {
          const saveName = await axios.post(
            "https://gallery.verynifty.io/api/name",
            {
              id: this.id,
              name: this.name,
              signature,
              publicAddress: this.$store.state.account,
            }
          );
          console.log(saveName.data);
        }
      );
    },
  },
  beforeMount: function () {},
  computed: {
    isConnected: function () {
      return this.$store.state.web3 != null;
    },
    wrappedNFTName: function () {
      return "Original vNFT";
    },
  },
  asyncComputed: {
    async calculatedTod() {
      let calculateTod = await this.$store.state.GameContract.methods
        .getAmountOfTOD((parseInt(this.buyTodWithAmount) * 10 ** 18).toString())
        .call();
      return calculateTod / 60 / 60;
    },
  },
  watch: {
    isConnected: function () {
      this.fetchPlayerInfo();
    },
  },
};
</script>

<style scoped>
.shake {
  /* Start the shake animation and make the animation last for 0.5 seconds */
  animation: shake 0.5s;

  /* When the animation is finished, start again */
  animation-iteration-count: infinite;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

/* end shake */
.drop {
  font-size: 8rem;
  width: 0.1em;
  height: 0.1em;
  border-radius: 0 100% 100% 100%;
  background-color: red;
  position: absolute;
  top: 70%;
  animation: drop 3s infinite both;
}
/* .drop:nth-child(1) {
  left: 0%;
} */
/* .drop:nth-child(2) {
  left: 14%;
  animation-delay: -0.4s;
} */
.drop:nth-child(3) {
  left: 39%;
  animation-delay: -1.5s;
}
.drop:nth-child(4) {
  left: 55%;
  animation-delay: -0.8s;
}
/* .drop:nth-child(5) {
  left: 82.5%;
  animation-delay: -1.3s;
} */

@keyframes drop {
  0% {
    transform: translateY(0) scaleX(0.85) rotate(45deg);
    animation-timing-function: ease-out;
  }
  60% {
    transform: translateY(120%) scaleX(0.85) rotate(45deg);
    animation-timing-function: ease-in;
  }
  80%,
  100% {
    transform: translateY(60vh) scaleX(0.85) rotate(45deg);
  }
}

/* end battle css */

/* The flip box container - set the width and height to whatever you want. We have added the border property to demonstrate that the flip itself goes out of the box on hover (remove perspective if you don't want the 3D effect */
.flip-box {
  background-color: transparent;
  width: 320px;
  height: 195px;
  perspective: 1000px;
  /* Remove this if you don't want the 3D effect */
}

/* This container is needed to position the front and back side */
.flip-box-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

/* Do an horizontal flip when you move the mouse over the flip box container */
/* .flip-box:hover .flip-box-inner {
            transform: rotateY(180deg);
        } */

.rotate {
  transform: rotateY(180deg);
}

/* Position the front and back side */
.flip-box-front,
.flip-box-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  /* Safari */
  backface-visibility: hidden;
}

/* Style the front side (fallback if image is missing) */
.flip-box-front {
  color: black;
}

/* Style the back side */
.flip-box-back {
  transform: rotateY(180deg);
}

.meter span {
  display: block;
  height: 100%;
}
.progress {
  -webkit-animation: progressBar 3s ease-in-out infinite;
  -webkit-animation-fill-mode: both;
  -moz-animation: progressBar 3s ease-in-out;
  -moz-animation-fill-mode: both;
}
@-webkit-keyframes progressBar {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
@-moz-keyframes progressBar {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
/*VUE TOOLTIP */

/*END VUE TOOLTIP*/
</style>
